import { render, staticRenderFns } from "./BulkJsonForm.vue?vue&type=template&id=6b370bd5"
import script from "./BulkJsonForm.vue?vue&type=script&lang=js"
export * from "./BulkJsonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports